import type { ReactElement } from 'react';
import { useT } from '../../../../app/di';
import { Button } from '../../../../ui-kit/Button/Button';
import { FormAlert, FormTextArea, useServerForm } from '../../../../ui-kit/form/form';
import type { ServerOutcome } from '../../../../ui-kit/form/server-errors';

/** PUB-UC-4: не публиковать — с необязательной причиной. */
export function CancelPublicationForm({ onSubmit }: { onSubmit(note: string): Promise<ServerOutcome> }): ReactElement {
  const { t } = useT();
  const { form, submit } = useServerForm<{ note: string }>({ defaultValues: { note: '' }, fields: ['note'], onSubmit: ({ note }) => onSubmit(note) });
  return (
    <form className="u-stack" onSubmit={submit} noValidate>
      <FormAlert form={form} />
      <FormTextArea control={form.control} name="note" label={t('publishing.package.cancelNote')} rows={2} disabled={form.formState.isSubmitting} />
      <div>
        <Button type="submit" variant="ghost" icon="close" loading={form.formState.isSubmitting}>
          {t('publishing.package.cancel')}
        </Button>
      </div>
    </form>
  );
}
